exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#add-products {\n  transition: 0.3s opacity ease;\n  opacity: 0;\n}\n#add-products.show {\n  opacity: 1;\n}\n#add-products .styler-wrapper {\n  padding-bottom: 10px;\n}\n", ""]);

// exports
